import Vue from 'vue'
    import Router from 'vue-router'
    import MainPage from '@/components/MainPage'
    import SendResultStatus from '@/components/SendResultStatus'
    import MainMenu from '@/components/MainMenu'
    import Content from '@/components/Content'
    import Map from '@/components/Map'
    import Contact from '@/components/Contact'
    import Profile from '@/components/Profile'
    import CalendarView from '@/components/CalendarView'
    import FormView from '@/components/FormView'

//    import FormResult from '@/components/FormResult'

    import HTML404 from '@/components/HTML404'
    var $urlRoot = "";
Vue.use(Router);

export default new Router({
//    mode: 'history', 
    routes: [
//        {
//            path: '/test',
//            name: 'HTML404',
//            component: HTML404
//        },
        {
            path: '/',
            redirect: "/home"
        },
        {
            path: '/home',
            name: 'MainPage',
            component: MainPage
        },
        {
            path: $urlRoot + '/content/:content_id',
            name: 'Content',
            component: Content
        },
        {
            path: $urlRoot + '/profile/:content_id',
            name: 'Profile',
            component: Profile
        },
        {
            path: $urlRoot + '/sendresult',
            name: 'sendresult',
            component: SendResultStatus
        },
        {
            path: $urlRoot + '/content/:content_id/:x*',
            name: 'Content',
            component: Content
        },
        {
            path: $urlRoot + '/maps',
            name: 'Map',
            component: Map
        },
        {
            path: $urlRoot + '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: $urlRoot + '/calendar',
            name: 'CalendarView',
            component: CalendarView
        },
        {
            path: $urlRoot + '/form/:form_name',
            name: 'FormView',
            component: FormView
        }
//        ,
//        {
//            path: $urlRoot + '/form-result',
//            name: 'FormResult',
//            component: FormResult
//        }

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js